<script>
  import { setContext } from "svelte";
  import { useParams } from "svelte-navigator";
  import PageBase from "../components/pages/PageBase.svelte";
  import Loading from "../components/pages/Loading.svelte";
  import { useMe } from "../hooks/useMe.js";
  import { useMyProjectPermission } from "../hooks/useMyProjectPermission.js";
  import { createPageContextValue, usePageContext } from "../components/pages/pageContext.js";
  import { setAutoAssemblyProjectContext } from "./AutoAssemblyProjectContext.js";

  const params = useParams();
  const projectId = $params.project
  const planId = $params.planId

  // setContext() needs to be before usePageContext(), because the latter refers to the context created in the former.
  setContext("page", createPageContextValue())
  const pageContext = usePageContext()
  pageContext.setHeaderProps({
    title: "Asprova Auto Assembly"
  })

  const me = useMe()
  const {permission} = useMyProjectPermission(projectId)

  const backTo = "/"

  $: setAutoAssemblyProjectContext({projectId, planId})
</script>

<PageBase backTo={backTo}>
  <!-- We need to discern undefined (loading) from null (no permission). -->
  {#if $me && $permission !== undefined}
    <slot projectId={projectId} user={$me} permission={$permission}/>
  {:else}
    <Loading/>
  {/if}
</PageBase>
